import axios from 'axios';
import store from './../redux/store';
import { setShowDialog, setErrorToast } from './../redux/reducer';
import urls from './urls';
const axiosInstance = axios.create({
    // withCredentials: true
});
axiosInstance.interceptors.request.use(
    async (config) => {
        config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('_jwt');
        if (!config.url.includes('user-login')) {
            store.dispatch(setShowDialog(true));
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);
axiosInstance.interceptors.response.use(
    (response) => {
        if (!response.config.url.includes('user-login')) {
            store.dispatch(setShowDialog(false));
        }
        return response;
    },
    async (error) => {
        store.dispatch(setShowDialog(false));
        if (!error.config.url.includes('user-login')) {
            store.dispatch(setErrorToast({
                flag: true,
                content: error.message,
            }));
        }

        if (error.response.status === 401 && !error.config.url.includes('user-login') ) {
            if(!error.response.config.url.includes('user-login')){
                localStorage.removeItem('_jwt');
                window.location.assign('/');
            }
        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
